import React, { FC } from 'react';
import styled from 'styled-components';
import { T } from '../../../shared/helpers';
import { Link, TextButton } from '../buttons';
import { ZSwitch } from '../zswitch';
import { ZTooltip } from '../ztooltip';

// Re-export everything from the ui-widgets section
export * from './section';
export * from './subSection';

export const QuickGuidesSection = styled.div`
    ${(props: any) => props.theme.additionalProperties?.isExternalLinksHidden && `display: none;`}
`;

export const CardList = styled.ul`
    padding: 10px 0;
    margin: 0;
    list-style: none;
`;

/**
 * Define the settings group list item
 */

const ZSwitchWrapper = styled.div`
    display: flex;
    align-items: center;

    span {
        margin-right: 10px;
    }
`;

const CardListItemContainer = styled.li<{ $xs: number }>`
    padding: 20px;
    display: grid;
    grid-template-columns: ${(props) => (props.$xs == 2 ? '30% auto' : props.$xs == 3 ? '1fr 2.75fr 0.25fr' : 'auto max-content')};
    grid-gap: 20px;
    align-items: center;

    &:not(:last-child) {
        border-bottom: 1px rgb(228, 226, 226) solid;
    }

    > span {
        font-size: ${(props) => props.theme.app.component.card.text.size};
        font-weight: ${(props) => props.theme.app.component.card.text.weight};
    }
`;

const CardListItemLink = styled(Link)`
    font-size: ${(props) => props.theme.app.component.card.text.size};
    font-weight: ${(props) => props.theme.app.component.card.text.weight};
    text-decoration: none;

    ${(props) =>
        !props.disabled &&
        `&:hover {
    text-decoration: underline;
  }`}
`;

const CardListItemTitle = styled.span`
    font-size: ${(props) => props.theme.app.component.card.text.size};
    font-weight: bold;
`;

const CardListItemDescription = styled.span`
    font-size: ${(props) => props.theme.app.component.card.text.size};
    font-weight: normal;
    color: #6b6b6b;
`;

const CardListItemTitleGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

interface CardListItemProps {
    title: string;
    text: string;
    disabled?: boolean;
    switchChecked?: boolean;
    onSwitchClick?: (switchChecked: boolean) => void;
    onClick?: () => void;
    actionLabel?: string;
    onActionClick?: () => void;
}

export const CardListItem: FC<CardListItemProps> = ({ title, disabled, text, switchChecked, onSwitchClick, onClick, actionLabel, onActionClick }) => {
    const columns = actionLabel != undefined ? 4 : switchChecked != undefined ? 3 : 2;
    return (
        <CardListItemContainer $xs={columns}>
            {actionLabel != undefined ? (
                <CardListItemTitleGroup>
                    <CardListItemTitle>{title}</CardListItemTitle>
                    <CardListItemDescription>{text}</CardListItemDescription>
                </CardListItemTitleGroup>
            ) : (
                <>
                    {onClick ? (
                        <CardListItemLink onClick={onClick} disabled={disabled}>
                            {title}
                        </CardListItemLink>
                    ) : (
                        <CardListItemTitle>{title}</CardListItemTitle>
                    )}
                    <span>{text}</span>
                </>
            )}
            {switchChecked != undefined && (
                <ZSwitchWrapper>
                    <ZTooltip position='top' title={switchChecked ? T._('Disable', 'Admin') : T._('Enable', 'Admin')}>
                        <ZSwitch checked={switchChecked} onChange={onSwitchClick != undefined ? () => onSwitchClick(switchChecked) : () => {}} />
                    </ZTooltip>
                </ZSwitchWrapper>
            )}
            {actionLabel && onActionClick && <TextButton onClick={onActionClick}>{actionLabel}</TextButton>}
        </CardListItemContainer>
    );
};
